import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard, Autoplay, EffectFade, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const sliderlogo = new Swiper(".sliderlogo", {
	modules: [Navigation, Pagination, Keyboard, Autoplay, EffectFade, A11y],
	loop: true,
	centeredSlides: true,
	slidesPerView: 1,
	spaceBetween: 20,
	preloadImages: true,
	threshold: 10,
	effect: 'fade',
	fadeEffect: {
		crossFade: true
	},
	autoplay: {
		delay: 2500,
		disableOnInteraction: false,
	},
	a11y: {
		enabled: true,
	}
});

const initSlider = (name, options = {}) => {
	const slider = document.querySelector(`.slider[data-slider="${name}"]`);

	if (!slider) return;

	const swiperContainer = slider.querySelector(".swiper");

	if (!swiperContainer) return;

	const paginationEl = slider.querySelector(".swiper-custom-pagination");

	new Swiper(swiperContainer, {
		modules: [A11y, Keyboard, Pagination],
		slidesPerView: 1,
		keyboard: {
			enabled: true,
		},
		a11y: {
			enabled: true,
			containerMessage: `${name} Slider`,
			slideRole: 'group',
			slideLabelMessage: 'Slide {index} von {slidesLength}',
		},
		pagination: {
			el: paginationEl,
			clickable: true,
			bulletClass: 'swiper-custom-bullet',
			bulletActiveClass: 'swiper-custom-bullet-active',
		},
		...options
	});
};

const initAllSliders = () => {
	initSlider('price', {
		 autoHeight: true,
	});
	initSlider('card', {
		slidesPerView: 1.2,
		spaceBetween: 10,
		breakpoints: {
			576: {
				slidesPerView: 1.5,
				spaceBetween: 20,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 32,
			},
		},
	});

	initSlider('app');
};

const initHowItWorks = () => {
	const widget = document.querySelector('.how-it-works[data-how-it-works="app"]');
	if (!widget) return;

	const steps = widget.querySelectorAll('.how-it-works-step');
	const mobileButtons = widget.querySelectorAll('.mobile-step-btn');
	const mobileSlides = widget.querySelectorAll('.mobile-step-slide');
	const desktopSlides = widget.querySelectorAll('.how-it-works-image .swiper-slide');
	const stepCounter = widget.querySelector('.step-counter-current');

	let swiper = null;

	const activate = (stepNum, fromSwiper = false) => {
		const s = String(stepNum);
		steps.forEach(el => el.classList.toggle('is-active', el.dataset.step === s));
		mobileButtons.forEach(btn => btn.classList.toggle('is-active', btn.dataset.step === s));
		mobileSlides.forEach(slide => slide.classList.toggle('is-active', slide.dataset.step === s));

		// Desktop: toggle opacity on slides
		desktopSlides.forEach(slide => {
			const img = slide.querySelector('img');
			if (img) slide.classList.toggle('is-active', img.dataset.stepImage === s);
		});

		// Update mobile step counter
		if (stepCounter) stepCounter.textContent = stepNum;

		// Mobile swiper: sync slide index without re-triggering
		if (swiper && !fromSwiper) {
			swiper.slideTo(stepNum - 1);
		}
	};

	activate(1);

	// Desktop tab clicks
	steps.forEach(step => {
		step.addEventListener('click', () => activate(Number(step.dataset.step)));
	});

	// Mobile icon button clicks
	mobileButtons.forEach(btn => {
		btn.addEventListener('click', () => activate(Number(btn.dataset.step)));
	});

	// Mobile swiper — only init on mobile
	const swiperEl = widget.querySelector('.how-it-works-swiper');
	if (swiperEl) {
		const initMobileSwiper = () => {
			if (window.innerWidth < 768 && !swiper) {
				swiper = new Swiper(swiperEl, {
					modules: [A11y],
					slidesPerView: 1,
					spaceBetween: 60,
					a11y: { enabled: true },
					on: {
						slideChange(s) {
							activate(s.activeIndex + 1, true);
						},
					},
				});
			} else if (window.innerWidth >= 768 && swiper) {
				swiper.destroy(true, true);
				swiper = null;
			}
		};

		initMobileSwiper();
		window.addEventListener('resize', initMobileSwiper);
	}
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		initAllSliders();
		initHowItWorks();
	});
} else {
	initAllSliders();
	initHowItWorks();
}